import React from "react";
import { MultiLineField, Typography, Flex } from "../../../components";

interface BioFieldProps {
  value: string;
  onChange: (value: string) => void;
}

export const BioField: React.FC<BioFieldProps> = ({ value, onChange }) => {
  return (
    <Flex direction="column" gap="xs">
      <Typography variant="caption" colorScheme="muted" as="span">Bio</Typography>
      <MultiLineField
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Tell us about yourself..."
        maxRows={3}
        fullWidth
      />
    </Flex>
  );
};